import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStackedBarChartAxis2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="stacked-bar-chart-axis-2"><path d="M3.75 3.75V20.25H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.25 17.75V9.75H12.75V17.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 17.75V6.75H18.25V17.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconStackedBarChartAxis2;
